import { z } from "zod/v3";

/**
 * Issue #476: an EvidenceSubmission frozen against a completed AuditCycle.
 *
 * Created in bulk by `auditor.completeAuditCycle` (one row per CES.activeForStatus
 * in the cycle's scope). Used by the auditor center to render the immutable
 * "what was delivered" view for closed cycles, and by EvidenceSubmission write
 * sites to refuse edits to pinned rows.
 */
export const AuditCycleSubmissionPinReasonSchema = z.enum([
  "cycle_complete",
]);

export type AuditCycleSubmissionPinReason = z.infer<
  typeof AuditCycleSubmissionPinReasonSchema
>;

export const AuditCycleSubmissionPinSchema = z.object({
  id: z.string(),
  auditCycleId: z.string(),
  evidenceSubmissionId: z.string(),
  pinReason: AuditCycleSubmissionPinReasonSchema,
  pinnedAt: z.date(),
  pinnedBy: z.string(),
});

export type AuditCycleSubmissionPinDTO = z.infer<
  typeof AuditCycleSubmissionPinSchema
>;
